import { render, staticRenderFns } from "./ViewPriceRangePurchase.vue?vue&type=template&id=aa9aa92e&scoped=true&"
import script from "./ViewPriceRangePurchase.vue?vue&type=script&lang=js&"
export * from "./ViewPriceRangePurchase.vue?vue&type=script&lang=js&"
import style0 from "./ViewPriceRangePurchase.vue?vue&type=style&index=0&id=aa9aa92e&lang=scss&scoped=true&"
import style1 from "./ViewPriceRangePurchase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9aa92e",
  null
  
)

export default component.exports